/* eslint-disable import/no-unused-modules */
import type { ReactNode } from 'react';
import { cn } from '@rocco/index';

interface TwoColumnsRowProps {
    /** The label text displayed on the left side of the row. */
    label: string;
    /** Optional custom content rendered on the left side, replacing the label. */
    leftChild?: ReactNode;
    /** Content displayed on the right side of the row. */
    children?: ReactNode;
    /** Additional class names for the outer row container. */
    className?: string;
    /** Additional class names for the left label span. */
    leftSpanClassName?: string;
    /** Additional class names for the right content container. */
    rightDivClassName?: string;
    /** Whether to apply justify-between to the row container. Defaults to true. */
    isJustifyBetween?: boolean;
    /** Whether to stack into two rows on mobile. Defaults to false (single row). */
    mobileStacked?: boolean;
    placeLeftChildInDiv?: boolean;
    placeRightChildDirectly?: boolean;
}

/** A two-column row used in proposal sections. */
const TwoColumnsRow = ({
    label,
    leftChild,
    className,
    leftSpanClassName,
    rightDivClassName,
    children,
    isJustifyBetween = true,
    mobileStacked = false,
    placeLeftChildInDiv = false,
    placeRightChildDirectly = false,
}: TwoColumnsRowProps) => {
    const leftContent = leftChild ?? label;

    return (
        <div
            className={cn(
                'flex items-start',
                mobileStacked ? 'flex-col md:flex-row' : 'flex-row',
                isJustifyBetween &&
                    (mobileStacked ? 'md:justify-between' : 'justify-between'),
                className,
            )}
        >
            {leftContent &&
                (placeLeftChildInDiv ? (
                    <div className={cn(leftSpanClassName)}>{leftContent}</div>
                ) : (
                    <span className={cn(leftSpanClassName)}>{leftContent}</span>
                ))}
            {placeRightChildDirectly ? (
                children
            ) : (
                <div
                    className={cn(
                        isJustifyBetween
                            ? mobileStacked
                                ? 'md:text-right'
                                : 'text-right'
                            : '',
                        rightDivClassName,
                    )}
                >
                    {children}
                </div>
            )}
        </div>
    );
};

export default TwoColumnsRow;
